import { render, staticRenderFns } from "./preferential-set.vue?vue&type=template&id=0b105178&scoped=true&"
import script from "./preferential-set.vue?vue&type=script&lang=js&"
export * from "./preferential-set.vue?vue&type=script&lang=js&"
import style0 from "./preferential-set.vue?vue&type=style&index=0&id=0b105178&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b105178",
  null
  
)

export default component.exports